/*@ngInject*/
module.exports = function () {
    return {
        scope: {
            regionSelectionOpen: '=',
            addresses: '=',
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function (unitsService, $timeout) {
            let vm = this;
            vm.counties = [];
            vm.institutions = [];
            vm.units = [];
            vm.selectedCounties = [];
            vm.selectedInstitutions = [];
            vm.selectedUnits = [];


            vm.$onInit = function () {
                unitsService.getCountyList().then(function (result) {
                    vm.counties = result.data;
                    vm.selectedCounties = _.uniq(_.map(vm.addresses, address => address.county));
                    if (vm.selectedCounties) {
                        const countyIds = _.map(vm.selectedCounties, c => c.id);
                        unitsService.getUnitChildren(countyIds).then(function (result) {
                            vm.units = result.data;
                            if (vm.units) {
                                vm.selectedUnits = _.compact(_.uniq(_.map(vm.addresses, address => address.unit)));
                                if (vm.selectedUnits) {
                                    const unitIds = _.map(vm.selectedUnits, u => u.id);
                                    unitsService.getUnitChildren(unitIds).then(function (result) {
                                        vm.institutions = result.data;
                                        vm.selectedInstitutions = _.compact(_.uniq(_.map(vm.addresses, address => address.institution)));
                                    });
                                }
                            }
                        });
                    }
                });
            };

            vm.removeAllRegionFilters = () => {
                vm.addresses = [];
                vm.selectedCounties = [];
                vm.selectedInstitutions = [];
                vm.selectedUnits = [];
                vm.institutions = [];
                vm.units = [];
            };

            vm.selectCounty = (val) => {
                if (val) {
                    const idx = _.findIndex(vm.selectedCounties, county => county.id === val.id);
                    if (idx > -1) {
                        vm.selectedCounties.splice(idx, 1);

                        if (vm.selectedCounties.length === 0) {
                            vm.institutions = [];
                            vm.units = [];
                            vm.selectedInstitutions = [];
                            vm.selectedUnits = [];
                        }
                    } else {
                        vm.selectedCounties.push(val);
                    }
                    vm.loadUnits();
                }
            };

            vm.loadInstitutions = () => {
                if (vm.selectedUnits.length > 0) {
                    const unitIds = _.map(vm.selectedUnits, i => i.id);
                    unitsService.getUnitChildren(unitIds).then((result) => {
                        vm.institutions = result.data;
                        vm.removeNotSelectedUnitInstitutions();
                        $timeout(() => {
                            document
                                .getElementById('institution_0')
                                .focus();
                        });
                    });
                }
            };

            vm.loadUnits = () => {
                if (vm.selectedCounties.length > 0) {
                    const countyIds = _.map(vm.selectedCounties, c => c.id);
                    unitsService.getUnitChildren(countyIds).then((result) => {
                        vm.units = result.data;
                        vm.removeNotSelectedCountyUnits();
                        $timeout(() => {
                            document
                                .getElementById('unit_0')
                                .focus();
                        });
                    });
                }
            };

            vm.removeNotSelectedCountyUnits = () => {
                if (vm.selectedUnits.length > 0) {
                    angular.forEach(vm.selectedUnits, unit => {
                        const idx = _.findIndex(vm.units, i => unit.id !== i.id);
                        if (idx > -1) {
                            vm.selectedUnits.splice(idx, 1);
                        }
                    });

                    if (vm.selectedUnits.length === 0) {
                        vm.institutions = [];
                        vm.selectedInstitutions = [];
                    }
                    vm.loadInstitutions();
                }
            };

            vm.removeNotSelectedUnitInstitutions = () => {
                if (vm.selectedInstitutions.length > 0) {
                    angular.forEach(vm.selectedInstitutions, institution => {
                        const idx = _.findIndex(vm.institutions, u => u.id !== institution.id);
                        if (idx > -1) {
                            vm.selectedInstitutions.splice(idx, 1);
                        }
                    });
                }
            };

            vm.selectUnit = (val) => {
                if (val) {
                    const idx = _.findIndex(vm.selectedUnits, unit => unit.id === val.id);
                    if (idx > -1) {
                        vm.selectedUnits.splice(idx, 1);

                        if (vm.selectedUnits.length === 0) {
                            vm.selectedInstitutions = [];
                            vm.institutions = [];
                        }
                    } else {
                        vm.selectedUnits.push(val);
                    }
                    vm.loadInstitutions();

                }
            };

            vm.selectInstitution = (val) => {
                if (val) {
                    const idx = _.findIndex(vm.selectedInstitutions, institution => institution.id === val.id);
                    if (idx > -1) {
                        vm.selectedInstitutions.splice(idx, 1);
                    } else {
                        vm.selectedInstitutions.push(val);
                    }
                        document
                            .getElementsByClassName('region-search').item(0)
                            .focus();
                }
            };

            vm.isUnitSelectedById = (id) => {
                const idx = _.findIndex(vm.selectedUnits, u => u.id === id);
                return idx > -1;
            };

            vm.isInstitutionSelectedById = (id) => {
                const idx = _.findIndex(vm.selectedInstitutions, i => i.id === id);
                return idx > -1;
            };

            vm.isCountySelectedById = (id) => {
                const idx = _.findIndex(vm.selectedCounties, c => c.id === id);
                return idx > -1;
            };

            vm.search = () => {
                vm.addresses = [];
                angular.forEach(vm.selectedCounties, county => {
                    if (_.findIndex(_.map(vm.selectedUnits, c => c.parent_code), u => county.id === u) > -1) {
                        angular.forEach(vm.selectedUnits, unit => {
                            if (_.findIndex(_.map(vm.selectedInstitutions, i => i.parent_code), i => unit.id === i)  > -1) {
                                angular.forEach(vm.selectedInstitutions, institution => {
                                    if (institution.parent_code === unit.id) {
                                        vm.addresses.push({county, unit, institution});
                                    }
                                });
                            } else if (unit.parent_code === county.id) {
                                vm.addresses.push({county, unit});
                            }
                        });
                    } else {
                        vm.addresses.push({county});
                    }
                });
                vm.regionSelectionOpen = false;

            };

            vm.close = () => vm.regionSelectionOpen = false;
        },

        template: require('./select-region.directive.html')
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/select-region.directive.js
 **/